import { useState } from "react";
import MenuContent from "../../components/layout/Sidebar/MenuContent";

export default function Menu() {
    const [isCollapsed, setIsCollapsed] = useState(false);
    return (
        <div style={{ width: "100%", height: "100vh", marginTop: "15px" , paddingBottom: "100px"}}>
            <MenuContent isCollapsed={isCollapsed} />
        </div>
    );
}